var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{attrs:{"tabKeys":_vm.keys,"titles":_vm.titles,"value":_vm.selectedKey,"withBorder":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }